import { render } from "./Register.vue?vue&type=template&id=3dd5a230"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Git\\Tepparad\\Tepparad-benefit-newver\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__